import { Status, useSession } from '@lendi/lala-react';
import { useEffect } from 'react';
import { analytics, AuthenticationStatus, ChatEventName, EventCategory } from '../..';
// track events when user clicks the chat on comm panel
export var useChatOpenTracking = function (isAParticipant, hasAuthedViaChat) {
    if (isAParticipant === void 0) { isAParticipant = true; }
    if (hasAuthedViaChat === void 0) { hasAuthedViaChat = false; }
    var status = useSession().status;
    useEffect(function () {
        var trackEventOnChatOpen = function () {
            if (status === Status.Authenticated) {
                // this track when user is authenticated but not via SmartChat.
                if (!hasAuthedViaChat) {
                    var event_1 = {
                        event_name: ChatEventName.OPENED,
                        category: EventCategory.CHAT,
                        authenticationStatus: AuthenticationStatus.AUTHENTICATED,
                        isAParticipant: isAParticipant,
                    };
                    analytics(event_1);
                }
            }
            else {
                // this track when user is not authenticated - which could be unauthenticated, errored, expired.
                var event_2 = {
                    event_name: ChatEventName.OPENED,
                    category: EventCategory.CHAT,
                    authenticationStatus: AuthenticationStatus.UNAUTHENTICATED,
                };
                analytics(event_2);
            }
        };
        trackEventOnChatOpen();
    }, [status, hasAuthedViaChat]);
};
//# sourceMappingURL=index.js.map